import { useTheme } from '@mui/material';
import { isIOS, isMobile } from 'react-device-detect';
import DSBox from '../../design-system/DSBox';
import { useGiftContext } from './Context/GiftContextProvider';
import GiftView from './GiftView';
import { DSTypography } from '../../design-system/Typography';
import DSSwitch from '../../design-system/DSSwitch';
import { useState } from 'react';
import {
  CLOCK_DIAMETER,
  KLYDO_WIDTH_WITHOUT_FRAME,
} from '../../consts/clockDimensions';

// Match editor dimensions:
// mobile iOS:     250×420px → scale ≈ 250/643 = 0.389
// mobile non-iOS: 230×380px → scale ≈ 230/643 = 0.358
// desktop:        290×483px → scale ≈ 290/643 = 0.451
const DESKTOP_SCALE = (CLOCK_DIAMETER / KLYDO_WIDTH_WITHOUT_FRAME) * 0.549; // ~0.451
const MOBILE_SCALE = 230 / KLYDO_WIDTH_WITHOUT_FRAME; // ~0.358
const MOBILE_IOS_SCALE = 250 / KLYDO_WIDTH_WITHOUT_FRAME; // ~0.389

const GiftViewContainer = () => {
  const theme = useTheme();
  const { klydoGiftProps, selectedKlydoGreet } = useGiftContext();
  const [showGreeting, setShowGreeting] = useState(false);

  const mobileScale = isIOS && isMobile ? MOBILE_IOS_SCALE : MOBILE_SCALE;

  return (
    <DSBox
      sx={{
        paddingTop: { xs: '20px', md: '30px' },
        paddingBottom: { xs: '10px', md: '0px' },
        backgroundColor: theme.palette.background.paper,
      }}
    >
      {isMobile ? (
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <GiftView
            gift={klydoGiftProps}
            klydo={selectedKlydoGreet!}
            isToggled={showGreeting}
            scale={mobileScale}
          />
          <DSBox
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              width: '100%',
              mt: 1,
            }}
          >
            <DSTypography
              sx={{
                fontFamily: 'Gilroy-SemiBold',
                fontSize: '16px',
                color: showGreeting ? '#A5A5A5' : '#FFFFFF',
              }}
            >
              Greet
            </DSTypography>
            <DSSwitch
              checked={showGreeting}
              onChange={(e) => setShowGreeting(e.target.checked)}
            />
            <DSTypography
              sx={{
                fontFamily: 'Gilroy-SemiBold',
                fontSize: '16px',
                color: showGreeting ? '#FFFFFF' : '#A5A5A5',
              }}
            >
              Message
            </DSTypography>
          </DSBox>
        </DSBox>
      ) : (
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
          }}
        >
          <DSBox
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <GiftView
              gift={klydoGiftProps}
              klydo={selectedKlydoGreet!}
              scale={DESKTOP_SCALE}
            />
            <DSTypography
              sx={{
                fontFamily: 'Gilroy-SemiBold',
                fontSize: '16px',
                color: '#FFFFFF',
              }}
            >
              Klydo
            </DSTypography>
          </DSBox>
          <DSBox
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <GiftView
              gift={klydoGiftProps}
              klydo={selectedKlydoGreet!}
              isToggled
              scale={DESKTOP_SCALE}
            />
            <DSTypography
              sx={{
                fontFamily: 'Gilroy-SemiBold',
                fontSize: '16px',
                color: '#FFFFFF',
              }}
            >
              Greeting
            </DSTypography>
          </DSBox>
        </DSBox>
      )}
    </DSBox>
  );
};

export default GiftViewContainer;
